export const WIDE_ONLY_CELL = { base: "none", md: "table-cell" };
export const NARROW_ONLY = { base: "block", md: "none" };
